import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lightbulb } from "lucide-react";

export const ProjetHero = ({ overline, title, img, alt }) => (
    <section className="relative flex min-h-[72svh] items-end overflow-hidden">
        <div className="absolute inset-0">
            <img src={img} alt={alt} className="h-full w-full object-cover rz-hero-zoom" />
            <div className="absolute inset-0 bg-gradient-to-b from-rz-deep/55 via-rz-deep/45 to-rz-deep/85" />
        </div>
        <div className="relative z-10 mx-auto w-full max-w-[1400px] px-6 md:px-12 pb-16 md:pb-24 pt-32">
            <motion.span
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.2 }}
                className="text-xs md:text-sm tracking-[0.25em] uppercase text-rz-pale"
            >
                {overline}
            </motion.span>
            <motion.h1
                initial={{ opacity: 0, y: 26 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.32, ease: [0.16, 1, 0.3, 1] }}
                className="font-display mt-5 max-w-4xl text-white font-extrabold tracking-tight leading-[1.02] text-[clamp(2.2rem,5.5vw,4.6rem)] [text-shadow:_0_2px_30px_rgba(10,26,18,0.45)]"
            >
                {title}
            </motion.h1>
        </div>
    </section>
);

export const SaviezVous = () => (
    <div
        data-testid="saviez-vous"
        className="flex items-start gap-5 rounded-2xl border border-rz-sage/30 bg-rz-pale/20 p-7 md:p-8"
    >
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-rz-green text-white">
            <Lightbulb size={22} />
        </span>
        <div>
            <p className="font-display text-lg font-bold text-rz-ink">Le saviez-vous ?</p>
            <p className="mt-2 text-sm md:text-base leading-relaxed text-rz-ink-soft">
                Dans de nombreuses régions, les constructions agricoles en bois bénéficient de
                subventions supplémentaires.
            </p>
        </div>
    </div>
);

export const ProjetCta = ({ text }) => (
    <section className="relative overflow-hidden bg-rz-deep px-6 md:px-12 py-20 lg:py-28">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "url('/images/pasture.jpg')", backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-rz-deep/70" />
        <div className="relative z-10 mx-auto max-w-[1400px] text-center">
            <h2 className="font-display mx-auto max-w-4xl text-[clamp(1.8rem,4.5vw,3.2rem)] font-extrabold tracking-tight leading-[1.05] text-white">
                {text}
            </h2>
            <Link
                to="/contact"
                data-testid="projet-cta-button"
                className="group mt-10 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-semibold text-rz-green transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/30"
            >
                Démarrer votre projet
            </Link>
        </div>
    </section>
);
